import { RiskConfig, RuleOperator } from "../app/modules/project";
const config = JSON.parse(localStorage.getItem("config") || "{}");
import { useNavigate, useLocation, NavigateFunction } from "react-router-dom";
import { clsx, type ClassValue } from "clsx";

export const stageCompletedCode = "stage_status_4";
export const procurementPlanOtherValue = "procurement_plan_5";
export const procurementActionOtherValue = "procurement_action_6";
export const socialImpactOtherValue = "social_impact_6";
export const SSAOtherValue = "sector_specific_analysis_4";
export const LandROtherValue = "legal_and_regulatory_type_10";
export const ProGovDepaOtherValue = "18";
export const PubEntRegBodOtherValue = "public_entities_and_regulatory_bodies_6";
export const SpeComBordOtherValue = "specialized_committees_and_boards_4";
export const ESJOtherValue = "economic_and_social_justification_6";
export const PIOtherValue = "policy_incentives_5";
export const TAMOtherValue = "total_addressable_market_4";
export const ObjectiveOtherValue = "project_objectives_5";
export const sectionOtherKey: any = {
  section_1: "sub_type_5",
  section_2: "sub_type_4",
  section_3: "sub_type_4",
  section_4: "sub_type_4",
  section_5: "sub_type_5",
};

export const costBenefitAnalysisOtherKey: any = {
  category: "category_5",
};

export const costEffectivenessAnalysisOtherKey: any = {
  effectiveness_metric: "effectiveness_metric_3",
  expected_outcome: "expected_outcome_3",
  intervention_type: "intervention_type_4",
  project_component: "project_component_3",
};

export const riskEvaluationOtherKey: any = {
  risk_category: "risk_category_6",
  risk_timeframe: "risk_time_frame_4",
};

export const economicMultipliersOtherKey: any = {
  employment_impact: "employment_impact_5",
  gdp_impact: "gdp_impact_7",
  key_drivers: "key_drivers_7",
  notes: "eco_multiplier_notes_7",
  sector_scenario: "eco_multiplier_sector_7",
};

export const macroEconomicBenefitsOtherKey: any = {
  benefit_category: "benefit_category_7",
  estimated_impact: "estimated_impact_9",
  policy_alignment: "policy_alignment_3",
  sectoral_relevance: "sectoral_relevance_7",
};

export const evenueModelOtherKey: any = {
  revenue_model_category: "revenue_model_category_4",
  specify: {
    revenue_model_category_1: "sub_type_5",
    revenue_model_category_2: "sub_type_5",
    revenue_model_category_3: "sub_type_4",
    revenue_model_category_4: "sub_type_3",
  },
};
export const OtherRelEntyKey = "rea_other_relevant_entities_4";
interface IENVCONFI {
  APP_EVE_API_URL: string;
  APP_PUBLIC_URL: string;
  APP_CURRENCY_SIGN: string;
  APP_CURRENCY_CODE: string;
  APP_SERVER: string;
  APP_COUNTRY_CODE: string;
  GOOGLE_MAPS_API_KEY: string;
  APP_TITLE: string;
  APP_GOV_TITLE: string;
  APP_API_ENCRYPTION: string;
  APP_API_SECRET: string;
  APP_TIME_FORMAT: string;
  APP_WEBSOCKET_URL: string;
  DEFAULT_INPUT_FIELD_SIZE: "sm" | "md" | "lg";
  REDUX_DEV_TOOL: boolean;
  APP_CHATBOT_WIDGET_VERSION: string;
  APP_WEATHER_DEFAULT_COORDINATES: {
    lat: number;
    lng: number;
  };
  APP_MEDIA_URL: string;
  APP_GIGAMAP_URL: string;
  APP_API_CLIENT_KEY: string;
  APP_API_CLIENT_DOMAIN: string;
  APP_PLATFORM_API_URL: string;
  /** Laravel Reverb — populated when VITE_REVERB_APP_KEY is set in build env */
  REVERB_APP_KEY: string;
  REVERB_HOST: string;
  REVERB_PORT: string;
  REVERB_SCHEME: string;
  /** true when VITE_REVERB_APP_KEY is present (Echo); false uses legacy WebSocket URL */
  USE_REVERB_NOTIFICATIONS: boolean;
}
const {
  VITE_APP_TITLE,
  VITE_APP_EVE_API_URL,
  VITE_APP_PUBLIC_URL,
  VITE_APP_CURRENCY_SIGN,
  VITE_APP_CURRENCY_CODE,
  VITE_APP_SERVER,
  VITE_APP_COUNTRY_CODE,
  VITE_APP_GOOGLE_MAPS_API_KEY,
  VITE_APP_GIGAMAP_URL,
  VITE_APP_API_ENCRYPTION,
  VITE_APP_API_SECRET,
  VITE_APP_TIME_FORMAT,
  VITE_APP_WEBSOCKET_URL,
  VITE_APP_REDUX_DEV_TOOL,
  VITE_APP_CHATBOT_WIDGET_VERSION,
  VITE_APP_WEATHER_DEFAULT_LATITUDE,
  VITE_APP_WEATHER_DEFAULT_LONGITUDE,
  VITE_APP_MEDIA_URL,
  VITE_APP_API_CLIENT_KEY,
  VITE_APP_API_CLIENT_DOMAIN,
  VITE_APP_PLATFORM_API_URL,
  VITE_REVERB_APP_KEY,
  VITE_REVERB_HOST,
  VITE_REVERB_PORT,
  VITE_REVERB_SCHEME,
  } = import.meta.env;

export const envConfig: IENVCONFI = {
  APP_EVE_API_URL: VITE_APP_EVE_API_URL,
  APP_PUBLIC_URL: VITE_APP_PUBLIC_URL,
  APP_CURRENCY_SIGN: VITE_APP_CURRENCY_SIGN,
  APP_CURRENCY_CODE: VITE_APP_CURRENCY_CODE,
  APP_SERVER: VITE_APP_SERVER,
  APP_COUNTRY_CODE: VITE_APP_COUNTRY_CODE,
  GOOGLE_MAPS_API_KEY: VITE_APP_GOOGLE_MAPS_API_KEY,
  APP_TITLE: VITE_APP_TITLE,
  APP_GOV_TITLE: "Governance Tools & Methods",
  APP_API_ENCRYPTION: VITE_APP_API_ENCRYPTION,
  APP_API_SECRET: VITE_APP_API_SECRET,
  APP_TIME_FORMAT: VITE_APP_TIME_FORMAT || "hh:mm a",
  APP_WEBSOCKET_URL: VITE_APP_WEBSOCKET_URL,
  REDUX_DEV_TOOL: VITE_APP_REDUX_DEV_TOOL === 'true' ? true : false,
  DEFAULT_INPUT_FIELD_SIZE: VITE_APP_SERVER === "qa" ? 'lg' : 'md',
  APP_CHATBOT_WIDGET_VERSION: VITE_APP_CHATBOT_WIDGET_VERSION,
  APP_WEATHER_DEFAULT_COORDINATES: {
    lat: VITE_APP_WEATHER_DEFAULT_LATITUDE,
    lng: VITE_APP_WEATHER_DEFAULT_LONGITUDE
  },
  APP_MEDIA_URL: VITE_APP_MEDIA_URL,
  APP_GIGAMAP_URL: VITE_APP_GIGAMAP_URL,
  APP_API_CLIENT_KEY: VITE_APP_API_CLIENT_KEY,
  APP_API_CLIENT_DOMAIN: VITE_APP_API_CLIENT_DOMAIN,
  APP_PLATFORM_API_URL: VITE_APP_PLATFORM_API_URL,
  REVERB_APP_KEY: VITE_REVERB_APP_KEY ?? "",
  REVERB_HOST: VITE_REVERB_HOST ?? "localhost",
  REVERB_PORT: VITE_REVERB_PORT ?? "8080",
  REVERB_SCHEME: VITE_REVERB_SCHEME ?? "http",
  USE_REVERB_NOTIFICATIONS: Boolean(VITE_REVERB_APP_KEY),
};

export const getFileNameFromPath = (path: string) => {
  return path.split("/").pop();
};
export const currencyFormatNumber = (
  val: string | number,
  maxDecimal: number = 3
): string => {
  if (val === '' || val === null || val === undefined) return '';

  const numericValue =
    typeof val === 'string'
      ? Number(val.replace(/[^0-9.-]/g, ''))
      : val;

  if (isNaN(numericValue)) return '';

  return numericValue.toLocaleString('en-US', {
    maximumFractionDigits: maxDecimal,
  });
};

export const currencyFormatNumberWithSign = (val: string | number): string => {
  return `${VITE_APP_CURRENCY_SIGN} ${currencyFormatNumber(val)}`;
};

export const getStageRedirectCustom = (fipdmgate: number, currentGateNum: number, project_id: string | number, stage_id: string) => {
  // Allow navigate to all stage
  return getProjectStageLink(project_id, stage_id);
  //return fipdmgate <= currentGateNum ? getProjectStageLink(project_id, stage_id) : "#"
}

export const getStageRedirect = (project_id: string | number, stage_id: string) => {
  //Allow navigate to all stage
  return getProjectStageLink(project_id, stage_id);

  //return (active_gate == 1 || stageStatusCompleted) ? getProjectStageLink(project_id, stage_id) : "#";
}

export const getStageNavigate = (navigate: NavigateFunction, project_id: string | number, stage_id: string, active_gate: number, stageStatusCompleted: boolean) => {
  //Allow navigate to all stage
  navigate(getProjectStageLink(project_id, stage_id));

  //(active_gate == 1 || stageStatusCompleted) && navigate(getProjectStageLink(project_id, stage_id));
}

export const getProjectStageLink = (
  project_id: string | number,
  dk_stage: string = ""
): string => {
  return dk_stage != ""
    ? `/manage-project/${project_id}/${dk_stage}`
    : `/manage-project/${project_id}`;
};

export const getDashboardStagegates = (): string => {
  return "/dashboard/stagegates";
};

export const getDashboardLink = (tabName: string = ""): string => {
  return tabName == "" || tabName == "dashboard"
    ? "/dashboard"
    : `/dashboard/${tabName}`;
};

export const stageStatusName: any = {
  stage_status_1: "upcoming",
  stage_status_2: "current",
  stage_status_3: "current",
  stage_status_4: "completed",
  stage_status_5: "current",
  stage_status_6: "blocked",
};

export const defaultMapCenter = {
  lat: -33.9249,
  lng: 18.4241,
};

export const MIN_NAME_LENGTH = 3;

export const accessOptions = ["Edit", "View"];

export const capitalize = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

// const sATO =(str:string) => {
//   // Step 1: Convert string to ASCII decimal values
//   const asciiValues = [...str].map((ch) => ch.charCodeAt(0));

//   // Step 2: Calculate average
//   const sum = asciiValues.reduce((a, b) => a + b, 0);
//   const average = sum / asciiValues.length;

//   // Step 3: Convert average to octal (return as number)
//   return parseInt(Math.round(average).toString(8), 10);
// }

// export const encode=(str:string)=>{
//   let encoded = "";

//   // double base64 encode with UTF-8 safety
//   str = btoa(unescape(encodeURIComponent(str)));
//   str = btoa(unescape(encodeURIComponent(str)));

//   const oSalt = sATO(VITE_APP_API_SECRET);

//   for (let i = 0; i < str.length; i++) {
//     const a = str.charCodeAt(i);
//     const b = a ^ oSalt; // bitwise XOR
//     encoded += String.fromCharCode(b);
//   }

//   encoded = btoa(encoded);
//   return encoded;
// }

// export const decodefn=(encoded:string)=>{
//   let decoded = atob(encoded); // base64 decode outer
//   let result = "";
//   const oSalt = sATO(VITE_APP_API_SECRET);

//   for (let i = 0; i < decoded.length; i++) {
//     const b = decoded.charCodeAt(i);
//     const a = b ^ oSalt; // XOR again with salt
//     result += String.fromCharCode(a);
//   }

//   // double base64 decode with UTF-8 safe handling
//   result = atob(result);
//   result = atob(result);

//   // Restore UTF-8
//   return decodeURIComponent(escape(result));
// }

export const encodeBase64 = (str: string): string => {
  return btoa(unescape(encodeURIComponent(str)));
};

export const decodeBase64 = (encoded: string): string => {
  return decodeURIComponent(escape(atob(encoded)));
}

// Generate unique colors for each project
export const getProjectColor = (index: number) => {
  const hue = (index * 137.508) % 360;
  return `hsl(${hue}, 70%, 50%)`;
};

export const getRiskConfig = (): RiskConfig => {

  let riskConfig: RiskConfig = {
    risk_score: {
      operator: ">=",
      value: 10
    },
    residual_risk_score: {
      operator: ">=",
      value: 10
    }
  };

  try {

    const rawRiskConfig = config?.config?.risk_config;

    if (!rawRiskConfig) {
      return riskConfig;
    }
    else if (typeof rawRiskConfig === "string") {
      riskConfig = JSON.parse(rawRiskConfig);
    }
    else {
      riskConfig = rawRiskConfig;
    }

  } catch (e) {
    console.warn("Invalid config in localStorage", e);
  }
  return riskConfig;
}

export const evaluateRule = (
  fieldValue: any,
  operator: RuleOperator,
  ruleValue: any
): boolean => {
  const a = Number(fieldValue);
  const b = Number(ruleValue);

  switch (operator) {
    case ">": return a > b;
    case "<": return a < b;
    case ">=": return a >= b;
    case "<=": return a <= b;
    case "==": return a === b;
    case "!=": return a !== b;
    default: return false;
  }
};

export const getProjectEvaluationLink = (project_id: string | number): string => {
  return `/pet/${project_id}`;
}

export const getProjectEvaluationStatusClass = (eval_status: string): string => {
  switch (eval_status) {
    case "Pending": return "bg-gradient-warning";
    case "In Progress": return "bg-gradient-primary";
    case "Overdue": return "bg-gradient-danger";
    case "Completed": return "bg-gradient-success";
    default: return "bg-gradient-primary";
  }
}

// src/utils/notification.ts
export const requestPermission = async (): Promise<void> => {
  if (!("Notification" in window)) return;

  const permission = await Notification.requestPermission();
  console.log("Permission:", permission);
};

export const requestLocationPermission = async (): Promise<GeolocationPosition | boolean> => {
  if (!("geolocation" in navigator)) {
    console.warn("Geolocation not supported");
    return false;
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve(position);
      },
      (error) => {
        resolve(false);
      }
    );
  });
};

export const pushNotification = (
  title: string,
  options?: NotificationOptions
): void => {
  if (Notification.permission === "granted") {
    const notification = new Notification(title, options);

    notification.onclick = () => {
      window.focus();
    };
  }
};

export const emptyDataValidation = [undefined, "undefined", null, "null", ""]

/** Dashboard (or other entry page) stored for Back. Ignores missing and "undefined" values. */
export const buildNavigationState = (from: unknown): { from: string } | undefined => {
  if (typeof from !== "string") {
    return undefined;
  }

  const origin = from.trim();
  if (emptyDataValidation.includes(origin) || origin.startsWith("undefined")) {
    return undefined;
  }

  return { from: origin };
};

export const useSmartNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goToDetails = (path: string) => {
    const preservedOrigin = buildNavigationState(location.state?.from)?.from;
    const origin = preservedOrigin ?? `${location.pathname}${location.search}`;

    navigate(`${path}${location.search}`, {
      state: { from: origin },
    });
  };

  const goBack = (path: string) => {
    const origin = buildNavigationState(location.state?.from)?.from;
    if (!origin) {
      navigate(path, { replace: true });
      return;
    }

    const target = origin.includes("?") || !location.search ? origin : `${origin}${location.search}`;
    navigate(target, { replace: true });
  };

  return { goToDetails, goBack };
};

type Props = {
  oldUI?: React.ReactNode;
  newUI?: React.ReactNode;
  fallback?: React.ReactNode;
};

export const EnvSwitch = ({ oldUI, newUI, fallback }: Props) => {
  const env = envConfig.APP_SERVER;
  if (env === "qa") return oldUI ?? fallback ?? null;
  if (env === "dev" || env === "local") return newUI ?? fallback ?? null;
  return fallback ?? null;
};

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

export const QuerySwitch = ({ oldUI, newUI }: Props) => {
  const query = new URLSearchParams(window.location.search);
  const layout = query.get("layout");
  switch (layout) {
    case "1": return oldUI ?? null;
    case "2": return newUI ?? null;
    default: return oldUI;
  }
};

export const denormalizeValue = (value: number | string, decimals = 3): string => {
  const numericValue =
    typeof value === "number" ? value : parseFloat(value) || 0;

  const format = (num: number) => {
    // Whole amounts drop their zero decimals: 2.00 => 2.
    return num.toFixed(decimals).replace(/\.0+$/, "");
  };

  if (numericValue >= 1_000_000_000_000) {
    return format(numericValue / 1_000_000_000_000) + " T";
  } else if (numericValue >= 1_000_000_000) {
    return format(numericValue / 1_000_000_000) + " B";
  } else if (numericValue >= 1_000_000) {
    return format(numericValue / 1_000_000) + " M";
  } else if (numericValue >= 1_000) {
    return format(numericValue / 1_000) + " K";
  } else {
    return format(numericValue);
  }
};

export function formatCommaSeparatedNumber(
  value: string | number | null | undefined
) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const num = Number(String(value).replace(/,/g, ""));

  return Number.isFinite(num)
    ? num.toLocaleString("en-US")
    : "";
}

export const INDICATOR_LIMITS = {
  min: 0,
  max: 999999999,
} as const;


export const QUERY_OPTIONS = {
  staleTime: 1000 * 60 * 30,  // 30 minutes
  gcTime: 1000 * 60 * 60, // 1 hour
  refetchOnWindowFocus: false // don't refetch on window focus
};


export const getInitials = (name: string): string => {
  return name
    .trim()
    .split(/\s+/)
    .map(word => word[0].toUpperCase())
    .join("");
};

export const toTitleCase = (text: string): string => {
  if (!text) return "";

  return text
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};